import { Reveal } from './reveal';

type SectionHeadProps = {
  title: string;
  lead?: string;
  eyebrow?: string;
};

export function SectionHead({ lead, title, eyebrow }: SectionHeadProps) {
  return (
    <Reveal className="section-head">
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {lead && <p className="lead">{lead}</p>}
    </Reveal>
  );
}
